module.exports = __webpack_public_path__ + "img/同步.b58d5c66.svg";